import { render, staticRenderFns } from "./listRecord.vue?vue&type=template&id=a45b0c84&"
import script from "./listRecord.vue?vue&type=script&lang=js&"
export * from "./listRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports